module.exports = require("@wildboar/x500/src/lib/modules/IDMProtocolSpecification/IDM-PDU.ta");